import React from "react";
import {useTranslation} from "react-i18next";

import EditResult from "../screens/Result/Popups/EditResult";
import EditProtocol from "../screens/Protocol/Popups/EditProtocol";
import ProtocolDetails from "../screens/Protocol/Popups/ProtocolDetails";

import { resultCRUD } from "../http";
import { protocolCRUD } from "../http";
import { protocolStateIds } from "../models/protocolStateIds";
import { withProtocolTypeContext } from "../models/protocolType";

export default function EditResultAndProtocolSection({ 
    editResultOpen, 
    setEditResultOpen, 
    editProtocolOpen,
    setEditProtocolOpen,
    editResultId,
    editProtocol,
    startLoading, 
    stopLoading,
    onEditResultSubmitted,
    onEditProtocolSubmitted,
    results
}) {
    results = results || [];

    const {t} = useTranslation();
    const protocolForUi = withProtocolTypeContext(editProtocol);
    const openProtocolDetails =
        Number(protocolForUi?.stateId) !== protocolStateIds.created;

    const editResultSubmit = async (_) => {
        await startLoading();

        await resultCRUD.edit(_);

        await stopLoading();

        _ = await resultCRUD.get(_.id);
        for (let i = 0; i < results.length; i++) {
            if (results[i].id == _.id) {
                results[i] = _;
                break;
            }
        }

        onEditResultSubmitted && onEditResultSubmitted(_);
    }

    const editProtocolSubmit = async (_) => {
        await startLoading();

        await protocolCRUD.edit(_);

        await stopLoading();

        onEditProtocolSubmitted && onEditProtocolSubmitted(_);
    }

    return (
        <>
            {editResultOpen && (
                <EditResult
                    idResult={editResultId}
                    action={'edit'} 
                    title={t("resultList.editText")} 
                    open={editResultOpen} 
                    setOpen={setEditResultOpen}
                    onSubmit={editResultSubmit}
                />
            )}
            {editProtocolOpen && openProtocolDetails && (
                <ProtocolDetails
                    action={'details'}
                    title={t("protocolList.detailsText")}
                    open={editProtocolOpen}
                    setOpen={setEditProtocolOpen}
                    protocol={protocolForUi}
                />
            )}
            {editProtocolOpen && !openProtocolDetails && (
                <EditProtocol 
                    action={'edit'} 
                    title={t("protocolList.editText")} 
                    open={editProtocolOpen} 
                    setOpen={setEditProtocolOpen} 
                    onSubmit={editProtocolSubmit} 
                    protocol={protocolForUi}/>
            )}
        </>
    )
}
